import { supabase, PCDoctor } from '../lib/supabase';
import { getTenantId } from '../contexts/TenantContext';

export const pcDoctorService = {
  async getAll(): Promise<PCDoctor[]> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('pc_doctors')
      .select('*')
      .eq('tenant_id', tenantId)
      .is('deleted_at', null)
      .order('name', { ascending: true });

    if (error) throw error;
    return data || [];
  },

  async getById(id: string): Promise<PCDoctor | null> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('pc_doctors')
      .select('*')
      .eq('id', id)
      .eq('tenant_id', tenantId)
      .is('deleted_at', null)
      .single();

    if (error) throw error;
    return data;
  },

  async create(pcDoctor: Omit<PCDoctor, 'id' | 'tenant_id' | 'created_at' | 'updated_at' | 'deleted_at'>): Promise<PCDoctor> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('pc_doctors')
      .insert({ ...pcDoctor, tenant_id: tenantId })
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async update(id: string, pcDoctor: Partial<PCDoctor>): Promise<PCDoctor> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('pc_doctors')
      .update(pcDoctor)
      .eq('id', id)
      .eq('tenant_id', tenantId)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async delete(id: string): Promise<void> {
    const tenantId = getTenantId();
    const { error } = await supabase
      .from('pc_doctors')
      .update({ deleted_at: new Date().toISOString() })
      .eq('id', id)
      .eq('tenant_id', tenantId);

    if (error) throw error;
  },

  async getActive(): Promise<PCDoctor[]> {
    const tenantId = getTenantId();
    const { data, error } = await supabase
      .from('pc_doctors')
      .select('*')
      .eq('tenant_id', tenantId)
      .eq('status', 'active')
      .is('deleted_at', null)
      .order('name', { ascending: true });

    if (error) throw error;
    return data || [];
  }
};
